import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { db } from "../components/Firebase";
import Loader from "../components/Loader";
import create from "../assets/images/create.jpeg";
import moment from "moment";

const News = () => {
  const [loader, setloader] = useState(true);
  const [counter, setCounter] = useState(0);
  const [isShow, invokeModal] = useState(false);
  const [news, setNews] = useState([]);
  //console.log("news", news);
  let navigate = useNavigate();
  const initModal = () => {
    return invokeModal(!isShow);
  };
  const closeModel = () => {
    invokeModal(false);
  };
  useEffect(() => {
    db.collection("news")
      .orderBy("date", "desc")
      .get()
      .then((i) => {
        let newNews = [];
        i.forEach((i) => {
          newNews.push({ ...i.data(), id: i.id });
        });
        setNews([...newNews]);
      });
  }, [counter]);

  return (
   
<div class="container-fluid">
  <div class="container">
    <div class="row">
      <div class="col-md-10" style={{ paddingBottom: "40px" }}>
        <h1 style={{ textAlign: "center" }}>News</h1>
      </div>
      <div class="col-md-2">
        {!isShow ? (
        <div onClick={() => { navigate("createNews"); initModal(); }} >
          <button class="btn btn-primary">Add New</button>
        </div>
      ) : null}
      </div>
    </div>

    {isShow ? (
      <div class="row">
        <Outlet context={{ invokeModal, setCounter, counter }} />
      </div>
    ) : (
     
    
    <div class="row">
      <div class="col-md-12">
        <table class="table table-striped table-bordered">
          <tbody>
            {news.map((i) => {
                //console.log(i);
                return (
            <tr onClick={() => { navigate("/dashboard/newsDetails", { state: { item: i } }); }}>
              <td>{i.title}</td>
              <td>{moment(i.date).format("D MMM, YYYY")}</td>
            </tr>
            );
              })}
          </tbody>
        </table>
      </div>
    </div>
)}
  </div>
</div>
  );
};

export default News;
